import PageContainer from '../../layouts/PageContainer/PageContainer'
import Text from '../../components/Text/Text'
import RegularLayout from '../../layouts/Regular/Regular'
import LinkWithArrow from '../../components/LinkWithArrow/LinkWithArrow'

const NotFound = () => (
  <RegularLayout>
    <PageContainer title="Not found">
      <Text>Please return to the homepage</Text>
      <LinkWithArrow to="/">Return home</LinkWithArrow>
    </PageContainer>
  </RegularLayout>
)

export default NotFound
